import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Birthdays } from '@store/models';

@Component({
    selector: 'app-birthdays-all',
    templateUrl: './birthdays-all.component.html',
    styleUrls: ['./birthdays-all.component.scss'],
    standalone: false
})
export class BirthdaysAllComponent {

    birthDays: Birthdays;

    constructor(
        public activeModal: NgbActiveModal
    ) {}

    gotoClient(kid: number) {
        this.activeModal.close(kid);
    }

}
